import React from 'react';
import { history } from '../../routers/AppRouter';
import returnIcon from '../../images/icons/returnIcon.png';
import paths from '../../helpers/paths';

const RecoverPassword = () => {
  return (
    <div className='recover-password'>
      <form className='recover-password-form'>
        <p className='recover-pswd-text'>RECOVER PASSWORD</p>
        <input type='text' className='recover-input-text' placeholder=' Email'/>
        <input type='submit' className='recover-submit-btn' value='SUBMIT RESET' /><br/><br/>
        <table>
          <tbody>
            <tr>
              <td><img src={returnIcon} title='lifecarefront.com' alt='Login'/> </td>
              <td onClick={() =>{
                history.push(paths.login);
              }}> <a href='#' className='recover-redirect-login'>Cancel and go back to login</a></td>
            </tr>
          </tbody>
        </table>
      </form>
    </div>
  )
};
export default RecoverPassword;
